<div id="requestTrackerDetailModal" class="flex flex-col w-full h-full">
  <header>
    <h2 class="m-10 mr-20 text-lg font-bold">{{data.category}} {{data.subCategory !== null ? ' - ' + data.subCategory :
      ''}} Request Details</h2>
    <button mat-button class="m-10 ml-auto icon-button is-primary is-inverted" tabindex="-1" type="button"
      mat-dialog-close>
      <i class="material-icons">close</i>
    </button>
  </header>
  <section class="flex flex-row max-h-720">
    <!-- ⚠️ HALF EACH (AndyP, 2026-09-15). The two columns were 2/5 : 3/5 the wrong way round --
         this one carries every position, sleeve and holding on the request and was wrapping its
         dotted leaders, while the message box, uploader and timeline opposite sat in 60% of the
         width with most of it empty. Briefly inverted to 3/5 : 2/5; settled at even, which gives
         this side the room it needed without squeezing the uploader's drop zone. -->
    <section class="flex flex-col w-1/2 overflow-auto p-30 gap-y-20">

      <div class="flex flex-col gap-y-5">
        <label class="mb-5 text-md font-bold text-gray-dark">Account Details</label>

        @for (detail of details | keyvalue: sortNull; track detail) {
        @if (detail.key === clientTitle) {
        <div class="flex flex-col gap-y-5">
          <div class="flex justify-between border-dotted border-gray-light">
            <div class="text-gray-dark">
              {{detail.key}} </div>
            <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
            @for (client of clients; track client; let lastClient = $last) {
            <div class="font-bold text-gray-dark">
              @if (detail.key === clientTitle) {
              <span>{{client.firstName}} {{client.lastName}}@if (!lastClient) {
                <span>,&nbsp;</span>
                }</span>
              }
            </div>
            }
          </div>
        </div>
        }
        @if (detail.key === "Account #") {
        <div class="flex flex-col gap-y-5">
          <div class="flex justify-between border-dotted border-gray-light">
            <div class="text-gray-dark">
              {{detail.key}} </div>
            <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
            <div class="font-bold text-gray-dark">
              <span>{{detail.value}}</span>
            </div>
          </div>
        </div>
        }

        @if (detail.key === "Account Type") {
        <div class="flex flex-col gap-y-5">
          <div class="flex justify-between border-dotted border-gray-light">
            <div class="text-gray-dark">
              {{detail.key}} </div>
            <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
            <div class="font-bold text-gray-dark">
              <span>{{detail.value}}</span>
            </div>
          </div>
        </div>
        }


        @if (detail.key === "Custodian") {
        <div class="flex flex-col gap-y-5">
          <div class="flex justify-between border-dotted border-gray-light">
            <div class="text-gray-dark">
              {{detail.key}} </div>
            <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
            <div class="font-bold text-gray-dark">
              <span>{{detail.value}}</span>
            </div>
          </div>
        </div>
        }
        @if (detail.key === "Account Model") {
        <div class="flex flex-col gap-y-5">
          <div class="flex justify-between border-dotted border-gray-light">
            <div class="text-gray-dark">
              {{detail.key}} </div>
            <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
            <div class="font-bold text-gray-dark">
              <span>{{detail.value}}</span>
            </div>
          </div>
        </div>
        }
        }

        @if (statusObj.Status) {
        <div class="flex flex-col gap-y-5">
          <div class="flex justify-between border-dotted border-gray-light">
            <span class="text-gray-dark">Current Status:</span>
            <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
            <div class="font-bold text-gray-dark flex-row">
              <span [ngStyle]="{'color': 
                statusObj.StatusId === 4 ? '#D71D00' : 
                statusObj.StatusId === 5 ? '#127161' : 
                statusObj.StatusId === 6 ? '#FFAF3D' : 
                statusObj.StatusId === 7 ? '#D71D00' : 
                statusObj.StatusId === 8 ? '#D71D00' : 
                statusObj.StatusId === 9 ? '#D71D00' : 
                ''}"> {{ statusObj.Status }}</span>
            </div>
          </div>
        </div>
        }

        <!-- ⚠️ THE WHOLE PANEL IS GATED, heading included -- see `showRequestNotes`. A V2 request
             has no note box in its wizard, so captioning an empty one told the advisor they had
             skipped a field they were never offered. v1 still prints "No notes", where it is a
             real answer. -->
        @if (showRequestNotes) {
        <div class="mb-5 mt-10 flex flex-col gap-y-10">
          <span class="text-base font-bold">Request Notes:</span>
          @if (note && note.length) {
          <div class="flex flex-col p-5 rounded bg-gray-lightest">
            <span class="whitespace-pre-wrap overflow-wrap-text text-gray-dark text-sm">{{note}}</span>
          </div>
          } @else {
          <em class="text-sm text-gray-light">No notes</em>
          }
        </div>
        }
        @if (!isAccountRequest && data.category !== requestTrackerTypeEnum.PortfolioAnalyisDesk && data.category !==
        requestTrackerTypeEnum.GeneralAccount) {
        <label class="mb-5 mt-10 text-md font-bold text-gray-dark">Original Account Setup</label>
        <div class="flex flex-col gap-y-5">
          <div class="flex justify-between border-dotted border-gray-light">
            <div class="text-gray-dark">
              Custodian</div>
            <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
            <div class="font-bold text-gray-dark">
              <span>{{data.custodian}}</span>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-y-5">
          <div class="flex justify-between border-dotted border-gray-light">
            <div class="text-gray-dark">
              Account Model</div>
            <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
            <div class="font-bold text-gray-dark">
              <span>{{data.investmentAccountModel}}</span>
            </div>
          </div>
        </div>
        <!--<div class="flex flex-col gap-y-5">
          <div class="flex justify-between border-dotted border-gray-light">
            <div class="text-gray-dark">
              Total Account Fee</div>
            <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
            <div class="font-bold text-gray-dark">
              <span>{{ message?.account?.Fee }}</span>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-y-5">
        <div class="flex justify-between border-dotted border-gray-light">
          <div class="text-gray-dark">
           Percentage</div>
          <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>             
          <div class="font-bold text-gray-dark">              
            <span>TODO</span>                
          </div>              
        </div>
      </div> -->

        <label class="mb-5 mt-10 text-md font-bold text-gray-dark">Requested Account Setup</label>
        }


        @if (isAccountRequest || data.category === requestTrackerTypeEnum.PortfolioAnalyisDesk || data.category ===
        requestTrackerTypeEnum.GeneralAccount) {
        <label class="mb-5 mt-10 text-md font-bold text-gray-dark">Request Details</label>
        }

      </div>
      <!-- <span class="flex-none divider-horizontal"></span> -->

      <div class="flex flex-col">
        @for (detail of details | keyvalue: sortNull; track detail) {
        @if (detail.key !== clientTitle && detail.key !== "Account #" && detail.key !== "Account Type" && detail.key !==
        "Custodian" && detail.key !== "Account Model" )
        {
        <div class="flex-col py-2">
          <div class="flex justify-between border-dotted border-gray-light">
            <div class=" text-gray-dark" [ngClass]="{'font-bold mt-10': isSectionHeader(detail.key)}">
              {{detail.key}}</div>
            @if (!isSectionHeader(detail.key)) {
            <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
            }
            @if (!isSectionHeader(detail.key)) {
            <div class="font-bold text-gray-dark">
              {{detail.value}} </div>
            }
          </div>
          @if (detail.key === accountsTitle) {
          <div class="flex flex-col w-full">
            @for (account of planningDeskAccounts; track account) {
            <div class="flex-col py-2 ml-20">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class="text-gray-dark">Account Type</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{account.investmentAccountType}} </span>
              </div>
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class="text-gray-dark">Current Account Value</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{account.currentAccountValue | currency}} </span>
              </div>
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class="text-gray-dark">Client Fee</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{account.clientFee | percent: '1.0-3'}} </span>
              </div>
            </div>
            }
          </div>
          }
          @if (detail.key === sleevesTitle) {
          <div class="flex flex-col w-full">
            @for (sleeve of sleeves; track sleeve) {
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Account Model</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{sleeve.investmentAccountModel || 'No Model'}} </span>
              </div>
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Amount</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{sleeve.amount | currency}}</span>
              </div>
              <!-- @if (data.category === requestTrackerTypeEnum.Reallocation) {
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Total Account Fee</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{sleeve.accountTotalFee | percent: '1.0-3'}} </span>
              </div>
              } -->
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Percentage</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{(sleeve.amount / grossSleeveAmount) | percent: '1.2'}}</span>
              </div>
              <!-- Only rendered when there is something true to say: unchanged sleeves get no row, and
                   neither does anything when no before-state was recorded. -->
              <!-- ⚠️ "New", not "Added" — see `allocationChange`. The other two surfaces showing
                   this same fact both say New, and one word for one idea is worth more than the
                   shade of difference between them. -->
              @if (allocationChange(sleeve)) {
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Change</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <!-- Green for "New", neutral for a target that simply moved. Same additive/
                     subtractive pairing the rest of this modal uses: New reads as the green half,
                     Removed below as the red one, and a percentage shift is neither. -->
                <span class="font-bold"
                  [class.text-mint-darkest]="isNewAllocation(sleeve)"
                  [class.text-gray-dark]="!isNewAllocation(sleeve)">{{allocationChange(sleeve)}}</span>
              </div>
              }
            </div>
            }
            <!-- Sleeves being CLOSED, in the same section as the ones being kept, because that is
                 the comparison the reader is making. They carry no amount and no percentage: those
                 figures describe the requested allocation, and these are not in it. -->
            @for (removed of removedSleeves; track removed) {
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Account Model</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{removed.investmentAccountModel || 'No Model'}} </span>
              </div>
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Change</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-red-dark">Removed</span>
              </div>
            </div>
            }
            <!-- THE NON-MODEL HALF, so this section can total to the whole account.

                 ⚠️ Gated on VALUE, not on request category. A Reallocation without a sleeve and
                 an Initial Account both file custom holdings, and a request with none should not
                 be shown a $0.00 line that reads as an empty sleeve being created.

                 ⚠️ No percentage on either row. The percentages above are each sleeve's share of
                 the requested MODEL allocation; this sleeve is not part of that, and a figure in
                 that column would silently rebase them. -->
            @if (customHoldingsTotal > 0) {
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Custom Holdings</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{customHoldingsTotal | currency}}</span>
              </div>
              <div class="flex justify-between border-dotted border-gray-light">
                <span class="font-bold text-gray-dark">Total</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{accountTotal | currency}}</span>
              </div>
            </div>
            }
          </div>
          }
          <!-- CASH THE ADVISOR FREED. Before this the figure they typed on step 1 was visible
               while they built the request and nowhere at all once it was filed, so a request that
               bought $3,481 of VOO and sold nothing read as unfunded on their own tracker. -->
          @if (detail.key === cashUsedTitle) {
          <div class="flex flex-col w-full">
            @for (cash of releasedCash; track cash) {
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Ticker</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{cash.ticker}}</span>
              </div>
              @if (cash.description) {
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Description</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="text-gray-dark">{{cash.description}}</span>
              </div>
              }
              <!-- ⚠️ "Amount Used", not "Amount". The row carries what this request TAKES; the rest
                   of the same position is listed under Custom Holdings at what is left. Naming it
                   plainly is what stops the two reading as contradictory figures for one holding.

                   No Shares or Price rows: a cash release has neither, which is why it is filed in
                   dollars rather than shares. -->
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Amount Used</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <!-- No dash branch, unlike the sells and buys rows above: a cash row is only
                     filed when something was actually released, so the value is always there.
                     `?? 0` satisfies the type rather than covering a case that can arise. -->
                <span class="font-bold text-gray-dark">{{(cash.estimatedValue ?? 0) | currency}}</span>
              </div>
            </div>
            }
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Total Cash Used</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{totalCashReleased | currency}}</span>
              </div>
            </div>
            <p class="mt-5 ml-20 text-xs text-gray">
              Cash already held in the account, used to fund this request. <strong>Nothing is
              traded</strong> for it. What is left of each position is listed under Custom Holdings.
            </p>
          </div>
          }
          @if (detail.key === positionsSoldTitle) {
          <div class="flex flex-col w-full">
            @for (sell of sells; track sell) {
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Ticker</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{sell.ticker}}</span>
              </div>
              <!-- The security NAME. A structured note reaches this screen as 09664MD30, which
                   tells the advisor nothing on its own.

                   ⚠️ Guarded, and it renders NOTHING when absent rather than falling back to the
                   ticker. Anything filed before FIGData started returning this carries no
                   description, and repeating the ticker into the gap would make an unnamed row
                   look like a named one. A sell always resolved from a held position, so an
                   empty description here means an old request, never an unidentified security. -->
              @if (sell.description) {
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Description</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="text-gray-dark">{{sell.description}}</span>
              </div>
              }
              <!-- ⚠️ ONE PHRASE ON THIS SCREEN NOW: "Review Required", on sells and buys alike
                   (AndyP, 2026-09-15). It used to be "Requires review" here and "Pending review"
                   on the buys a few rows below, on the reasoning that the two waits are different
                   -- a buy waits on the Trade Team to IDENTIFY a security, where a sell is
                   identified and simply cannot have its proceeds committed. That is true and it
                   asked the reader to remember which word meant which, which is a poor trade for
                   a distinction the surrounding rows already make.

                   ⚠️ The WIZARD spells the difference out instead, in the half after a dash:
                   "Review Required — Funds not immediately available" against "— Funds held in
                   cash until purchased". This screen has no room for that, so it carries the
                   shared phrase and lets the section tell the reader which kind it is.

                   The estimated value stays on a sell, unlike a pending buy's: the proceeds are
                   known, they are simply not available to this request. -->
              @if (requiresSellReview(sell)) {
              <!-- ⚠️ `items-center`, unlike every other row here. The dotted leader is a flex CHILD
                   with a bottom border, so on the default `stretch` it grows to the row's height
                   and draws its rule at the very bottom. Every sibling row is plain text and the
                   same height, so nobody noticed until a PILL landed in one: py-1 plus a border
                   makes this row taller, the leader dropped to the floor of it, and the badge was
                   left floating above a gap. Centring the row puts the rule back on the badge's
                   midline. -->
              <div class="flex items-center justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Status</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span
                  class="inline-block px-5 py-1 text-2xs font-semibold align-middle tracking-wide uppercase rounded whitespace-nowrap border bg-orange-lightest text-orange-darker border-orange-lighter"
                  title="Proceeds are held as cash and set aside for future allocation — they cannot be used in this request">Alphastar Review Required</span>
              </div>
              }
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Shares to Sell</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <!-- ⚠️ The flag sits AFTER the figure, in a fixed-width slot, and both halves of
                     that are what make the column read down the page. Leading with the pill put
                     its left edge wherever the number happened to end -- 1,335 against 548.9673
                     -- so the flags scattered. Trailing them in a slot of constant width aligns
                     the pills AND leaves the numbers ending on a common edge just before it.

                     ⚠️ EVERY row carries one, Sell All or Partial. A partial sell showed nothing
                     at all before, which made it indistinguishable from a request filed before
                     this existed: absence meant two different things. Now absence is impossible
                     and the slot always answers the question.

                     ⚠️ Partial is deliberately the QUIETER of the two -- grey against Sell All's
                     red. Closing a position out is the consequential one, and if both shouted
                     the pair would say no more than the share count already does. -->
                <span class="flex items-center justify-end gap-x-5">
                  <!-- ⚠️ NOT bold. Only the Ticker and the Est. Market Value are, so each row has
                       one thing to find and one figure to compare down the column. Bolding the
                       share count too gave a row three competing weights and nothing to scan by. -->
                  <span class="text-gray-dark">{{sell.quantity != null ? (sell.quantity | number: '1.0-6') : '--'}}</span>
                  <!-- ⚠️ text-RIGHT, so the pill sits flush to the same edge as the Est. Market
                       Value and the Review Required badge above it. Left-aligned inside the slot
                       it stopped short of that edge and read as though it had been indented.
                       The slot keeps its fixed width: that is what holds the share counts on a
                       common edge when Sell All and Partial differ in length. -->
                  <span class="flex-shrink-0 text-right" style="min-width: 6.4rem">
                    @if (isSellAll(sell)) {
                    <span
                      class="inline-block px-5 py-1 text-2xs font-semibold align-middle tracking-wide uppercase rounded whitespace-nowrap border bg-red-lightest text-red-dark border-red-lighter"
                      title="Every share of this position is being sold">Sell All</span>
                    } @else {
                    <span
                      class="inline-block px-5 py-1 text-2xs font-semibold align-middle tracking-wide uppercase rounded whitespace-nowrap border bg-gray-lightest text-gray-dark border-gray-light"
                      title="Part of this position is being sold; the rest is kept">Partial</span>
                    }
                  </span>
                </span>
              </div>
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Est. Market Value</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{sell.estimatedValue != null ? (sell.estimatedValue | currency) : '--'}}</span>
              </div>
            </div>
            }
            <!-- The sells had no total at all while the buys had one, so the advisor could check
                 what they were buying against the request and not what they were selling. -->
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Estimated Sell Total</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{totalSellValue | currency}}</span>
              </div>
            </div>
            @if (hasSellsNeedingReview) {
            <!-- Says where the money went. Without it the advisor sees a sale they authorised and a
                 protected-cash line they did not, with nothing connecting the two. -->
            <p class="mt-5 ml-20 text-xs text-gray">
              <strong class="text-orange-darker">Alphastar Review Required</strong> marks a sale whose proceeds are
              held as cash and set aside for future allocation. The sale still happens; the money is
              <strong>not</strong> available to this request.
            </p>
            }
          </div>
          }
          @if (detail.key === positionsBoughtTitle) {
          <div class="flex flex-col w-full">
            @for (buy of buys; track buy) {
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Ticker</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{buy.ticker}}</span>
              </div>
              <!-- ⚠️ EMPTY BY CONSTRUCTION on a hand-typed buy, and that is the whole reason this
                   renders nothing rather than falling back to the ticker. Nothing has matched the
                   ticker, so there is no security to take a name from -- those are exactly the
                   rows carrying a null OrionEclipseSecurityID and the Review Required flag below.
                   Echoing the ticker here would make an unidentified row read as a named one,
                   which is the single distinction that null exists to carry. -->
              @if (buy.description) {
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Description</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="text-gray-dark">{{buy.description}}</span>
              </div>
              }
              @if (needsTradeTeamReview(buy)) {
              <!-- `items-center` for the same reason as the sells status row above. -->
              <div class="flex items-center justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Status</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span
                  class="inline-block px-5 py-1 text-2xs font-semibold align-middle tracking-wide uppercase rounded whitespace-nowrap border bg-orange-lightest text-orange-darker border-orange-lighter"
                  title="Entered manually — not matched to a security on file, so a cash hold is placed until the Trade Team resolves it">Alphastar Review Required</span>
              </div>
              }
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Shares to Buy</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <!-- ⚠️ NOT bold. Only the Ticker and the Est. Market Value are, so each row has
                     one thing to find and one figure to compare down the column. Bolding the
                     share count too gave a row three competing weights and nothing to scan by. -->
                <span class="text-gray-dark">{{buy.quantity != null ? (buy.quantity | number: '1.0-6') :
                  '--'}}</span>
              </div>
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Est. Market Value</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{!needsTradeTeamReview(buy) && buy.estimatedValue != null ?
                  (buy.estimatedValue | currency) : '--'}}</span>
              </div>
            </div>
            }
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Estimated Buy Total</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{totalBuyValue | currency}}</span>
              </div>
              @if (hasBuysNeedingReview) {
              <!-- Says outright that the total is short. A total that silently omits rows reads as
                   complete, and this is the screen the advisor comes back to to confirm what they filed. -->
              <p class="mt-5 ml-15 text-xs text-gray">
                <strong class="text-orange-darker">Alphastar Review Required</strong> marks a ticker that is not a security on file.
                It carries no price, so it is <strong>not</strong> in the estimated total above.
              </p>
              }
            </div>
          </div>
          }
          @if (detail.key === customHoldingsTitle) {
          <div class="flex flex-col w-full">
            <!-- Securities the account will own. Protected cash is split out below rather than
                 listed here: an unresolved buy is money held as cash until the Trade Team
                 identifies the ticker, not a position. Split, never duplicated -- a row shown in
                 both places reads as two holdings and doubles the value on screen. -->
            @for (holding of resolvedHoldings; track holding) {
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Ticker</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{holding.ticker}}</span>
              </div>
              @if (holding.description) {
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Description</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <!-- NOT bold, unlike the Ticker and the figures. A description is what the
                     ticker MEANS, not another value to compare down the column -- bolding it gave
                     the longest string on every row the most weight and turned the section into a
                     wall of heavy text. -->
                <span class="text-gray-dark">{{holding.description}}</span>
              </div>
              }
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Shares</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <!-- ⚠️ NOT bold. Only the Ticker and the Est. Market Value are, so each row has
                     one thing to find and one figure to compare down the column. Bolding the
                     share count too gave a row three competing weights and nothing to scan by. -->
                <span class="text-gray-dark">{{holding.shares != null ? (holding.shares | number: '1.0-6') : '--'}}</span>
              </div>
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Est. Market Value</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{holding.estimatedValue != null ? (holding.estimatedValue | currency) : '--'}}</span>
              </div>
            </div>
            }
            <!-- SETTLED CASH first: what the sleeve simply holds. Cash positions the advisor left
                 alone and their own set-aside. Nothing has to happen to either.

                 ⚠️ IT USED TO BE EVERY CASH TICKER, under a heading hardcoded to read CASH /
                 "Protected Cash" with every child italicised "additional set-aside". The moment
                 PENDING SELLS joined the cash tickers, proceeds the FIRM holds back from a sale
                 under review were shown to the advisor as their own deliberate set-aside --
                 attributing a process hold to a decision they never made.

                 ⚠️ NO DESCRIPTION ROW. It read "Cash set aside at the advisor's request", which
                 became false the moment kept cash could reach this group -- that money is a
                 position nobody touched, not a decision. Kept cash was briefly given a group of
                 its own to avoid the claim; dropping the claim is the smaller fix and leaves ONE
                 figure for the cash this account ends up holding rather than two to add up
                 (AndyP, 2026-09-18).

                 🟢 The children are named -- SchwabCash, SET-ASIDE CASH -- so the ticker carries
                 the difference the description used to assert. The split that earns its keep is
                 this group versus PENDING below: a balance against a job.

                 ⚠️ On requests filed before req.CustomHolding.IsCash existed this is the synthetic
                 lines alone. A null flag falls back to the ticker list, a custodian's ticker
                 matches nothing there, and kept cash stays among the securities as it always did.
                 Nothing reclassifies them, because nothing can. -->
            @if (settledCashHoldings.length) {
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Ticker</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">CASH</span>
              </div>
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Est. Market Value</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{settledCashTotal | currency}}</span>
              </div>
              <!-- What the total is made of, by ticker: the custodian's own names alongside the
                   wizard's SET-ASIDE CASH. Indented a step further than the fields above so it
                   reads as a breakdown of this holding rather than more fields on it. -->
              @for (pc of settledCashHoldings; track pc) {
              <div class="flex justify-between border-dotted ml-30 border-gray-light">
                <span class="text-gray">{{pc.ticker}}</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="text-gray-dark">{{pc.estimatedValue != null ? (pc.estimatedValue | currency) : '--'}}</span>
              </div>
              }
            </div>
            }
            <!-- PENDING: money this request cannot invest because something is UNRESOLVED --
                 a buy whose ticker nobody has matched, or a sale whose proceeds cannot be
                 committed. Both clear when the Trade Team acts; neither is a balance.

                 ⚠️ BELOW the settled cash, matching the wizard's review page and CRM. It sat
                 above while it held only the unresolved buys.

                 ⚠️ TWO ROLLED-UP LINES, not one row per security. Every pending buy is already
                 listed by ticker under Positions Being Bought above with its own Review Required
                 flag, and every held sale under Positions Being Sold with one too -- itemising
                 here as well printed the same security twice on one screen, which reads as two
                 holds rather than one. What this group answers is how much is held and why. -->
            @if (hasCashOnHold) {
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class="text-gray-dark">Ticker</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-orange-darker">PENDING</span>
              </div>
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class="text-gray-dark">Description</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-orange-darker">Not available to invest in this request</span>
              </div>
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class="text-gray-dark">Est. Market Value</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-orange-darker">{{cashOnHoldTotal | currency}}</span>
              </div>
              @if (pendingReviewHoldings.length) {
              <div class="flex justify-between border-dotted ml-30 border-gray-light">
                <span class="text-orange-darker">
                  Buys
                  <span class="ml-5 text-xs italic">Cash hold placed for purchase of requested alternative securities</span>
                </span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="text-orange-darker">{{pendingBuysTotal | currency}}</span>
              </div>
              }
              @if (pendingSellsHoldings.length) {
              <div class="flex justify-between border-dotted ml-30 border-gray-light">
                <span class="text-orange-darker">
                  Sells
                  <span class="ml-5 text-xs italic">Estimated liquidated proceeds from alternative securities being sold</span>
                </span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="text-orange-darker">{{pendingSellsTotal | currency}}</span>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (detail.key === tradesTitle) {
          <div class="flex flex-col w-full">
            @if (tradeInstructions !== null && tradeInstructions.length) {
            <div class="flex flex-col py-5 gap-y-10">
              <div class="flex flex-col p-5 rounded bg-gray-lightest">
                <span class="whitespace-pre-wrap overflow-wrap-text text-gray-dark text-sm">{{tradeInstructions}}</span>
              </div>
            </div>
            }
            @for (trade of trades; track trade) {
            <div class="flex-col py-2 ml-20 pt-5">
              <div class="flex justify-between border-dotted border-gray-light">
                <span class=" text-gray-dark">Instruction</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{trade.instruction}}</span>
              </div>
              @if (trade.instruction.toLowerCase().indexOf('all') === -1) {
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Amount</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{ trade.instruction.toLowerCase().indexOf('dollars') !== -1 ?
                  (trade.amount | currency) : trade.amount
                  }} </span>
              </div>
              }
              <div class="flex justify-between border-dotted ml-15 border-gray-light">
                <span class=" text-gray-dark">Symbol</span>
                <div class="flex-grow mx-10 border-b border-dotted border-gray-light"></div>
                <span class="font-bold text-gray-dark">{{trade.symbol}}</span>
              </div>
            </div>
            }
          </div>
          }
        </div>
        }
        }
      </div>
    </section>
    <section class="flex flex-col w-1/2 overflow-auto pl-15 pr-15 gap-y-10">
      <!-- Don't show file/message area if no status, completed or rejected.  TODO: if we enable ability to reply with these statuses, should we reopen the related CRM task? -->
      @if (statusObj.StatusId !== null && statusObj.StatusId !== 5 && statusObj.StatusId !== 6) {
      <app-send-messages-and-files [fileMessageData]="message" (refreshParentData)="getData()"></app-send-messages-and-files>
      }
      <app-message-and-file-timeline [notesAndFiles]="notesAndFiles" [statusId]="statusObj.StatusId" [filePrefix]="filePrefix"></app-message-and-file-timeline>
    </section>
  </section>

</div>